import(/* webpackMode: "eager" */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/node_modules/next/dist/client/components/app-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/node_modules/next/dist/client/components/not-found-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/node_modules/next/dist/client/components/render-from-template-context.js");
